export default __webpack_public_path__ + "static/media/394.9da257aa.gif";